import { render, staticRenderFns } from "./PastDiagnosis.vue?vue&type=template&id=35ee0f26"
import script from "./PastDiagnosis.vue?vue&type=script&lang=js"
export * from "./PastDiagnosis.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports